module.exports = __webpack_public_path__ + "static/media/compare.0ef70c22.svg";